import { authFetch, getAuthHeaders } from '../lib/keycloak-api';

/**
 * Get route with multiple waypoints using Delhivery Routing API
 * @param {Array} waypoints - Array of {lat, lng} objects
 * @param {String} travelMode - Travel mode: 'auto', 'motorcycle', 'truck', 'pedestrian'
 * @returns {Object} Route data with geometry
 */
export const getMultiWaypointRoute = async (waypoints, travelMode = 'auto') => {
  try {
    if (!waypoints || waypoints.length < 2) {
      throw new Error('Need at least 2 waypoints');
    }

    const url = 'https://dlvroute-maps-pub-int.delhivery.com/v1/route';
    
    // Convert waypoints to geo_coords format [[lat, lng], [lat, lng], ...]
    const geo_coords = waypoints.map(wp => [wp.lat, wp.lng]);
    
    const requestBody = {
      geo_coords: geo_coords,
      travel_mode: travelMode
    };

    const headers = await getAuthHeaders();
    const response = await authFetch(url, {
      method: 'POST',
      headers: {
        ...headers,
      },
      body: JSON.stringify(requestBody)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (!data.status || !data.recommended_route) {
      throw new Error('No route found');
    }

    // Transform Delhivery API response to match OSRM format
    const route = data.recommended_route;
    
    // Convert geometry array [[lat, lng], ...] to GeoJSON format [[lng, lat], ...]
    const coordinates = route.geometry.map(coord => [coord[1], coord[0]]);
    
    return {
      distance: route.distance * 1000, // Convert km to meters
      duration: route.duration, // Already in seconds
      geometry: {
        type: 'LineString',
        coordinates: coordinates
      },
      legs: route.legs || [],
      weight: route.duration,
      weight_name: 'duration'
    };
  } catch (error) {
    throw error;
  }
};

